/* SeeMy — accessibilité : contrôle des vidéos en lecture automatique (WCAG 2.2.2) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ICON_PAUSE = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M6 4h4v16H6zM14 4h4v16h-4z"/></svg>';
  var ICON_PLAY = '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M7 4l13 8-13 8z"/></svg>';

  function setup(video) {
    if (video.dataset.smA11y) return;
    video.dataset.smA11y = '1';
    var host = video.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-video-toggle';
    function render() {
      var paused = video.paused;
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Lire la vidéo d’arrière-plan' : 'Mettre en pause la vidéo d’arrière-plan');
      btn.innerHTML = paused ? ICON_PLAY : ICON_PAUSE;
    }
    btn.addEventListener('click', function () {
      if (video.paused) { video.play(); } else { video.pause(); }
    });
    video.addEventListener('play', render);
    video.addEventListener('pause', render);
    if (reduce) { video.removeAttribute('autoplay'); video.pause(); }
    host.appendChild(btn);
    render();
  }

  function init() {
    document.querySelectorAll('video[autoplay], video[loop]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* SeeMy — boutons flottants (réserver un soin + WhatsApp) et widget cookies Pandectes
   Audit UX oct. 2026 — F01, F06, M01, M06 :
   - bulles jamais au panier ; « Réserver » jamais sur les fiches produit ni les formations ;
   - bulles et widget cookies masqués dès qu'un bouton de réservation, d'achat ou de paiement
     est déjà à l'écran, et quand le menu, la recherche ou le tiroir panier est ouvert ;
   - le widget cookies suit exactement la bulle WhatsApp : même taille, même hauteur, en miroir à gauche,
     affiché et masqué en même temps (donc aussi masqué au panier).
   Le bandeau de consentement n'est jamais masqué ; le lien « Gestion des cookies » du pied de page reste. */
(function () {
  if (window.__smFloat) return;
  window.__smFloat = true;
  var PLANITY = 'https://www.planity.com/seemy-cosmetics-75008-paris';
  var WHATSAPP = 'https://wa.me/33766481819';

  var PROTECT = [
    'main a[href*="planity.com"]',
    'main a[href*="booking.seemycosmetics"]',
    'main .ss-ctas',
    'main [data-smp-add]',
    'main .product-form__submit',
    '#checkout',
    '.cart__checkout-button',
    '.sm-footer__cta',
    '[data-sm-float-protect]'
  ].join(',');

  /* Widget cookies aligné sur la bulle WhatsApp (même taille, même hauteur, côté gauche) :
     les mesures viennent des variables --sm-fl-* posées sur pandectes-cmp dans seemy-a11y.css. */
  var COOKIE_CSS = '.widget{left:var(--sm-fl-x,16px)!important;right:auto!important;top:auto!important;' +
      'bottom:var(--sm-fl-b,16px)!important;width:var(--sm-fl-s,52px)!important;height:var(--sm-fl-s,52px)!important;' +
      'padding:calc(var(--sm-fl-s,52px) * .25)!important;box-sizing:border-box!important;' +
      'box-shadow:0 8px 24px -6px rgba(14,19,36,.35)!important;transition:opacity .25s ease,transform .25s ease}' +
    ':host([data-sm-hide]) .widget{opacity:0!important;visibility:hidden!important;pointer-events:none!important;' +
      'transform:translateY(12px);transition:opacity .2s ease,transform .2s ease,visibility 0s linear .2s}';

  function init() {
    var main = document.querySelector('main[data-template]');
    var tpl = main ? main.getAttribute('data-template') : '';
    var isCart = tpl.indexOf('cart') === 0;

    var wrap = null;
    if (!isCart) {
      wrap = document.createElement('div');
      wrap.className = 'sm-float';
      if (tpl.indexOf('product') === 0) wrap.classList.add('sm-float--product');
      wrap.innerHTML =
        '<a class="sm-float__book" href="' + PLANITY + '" target="_blank" rel="noopener">' +
          '<span class="sm-float__long">Réserver un soin</span><span class="sm-float__short">Réserver</span>' +
          '<span class="visually-hidden"> (nouvelle fenêtre)</span></a>' +
        '<a class="sm-float__wa" href="' + WHATSAPP + '" target="_blank" rel="noopener" aria-label="Nous écrire sur WhatsApp (nouvelle fenêtre)">' +
          '<svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true" focusable="false"><path fill="currentColor" d="M16.04 3C9 3 3.3 8.7 3.3 15.74c0 2.25.59 4.44 1.7 6.37L3.2 28.8l6.86-1.8a12.7 12.7 0 0 0 5.97 1.52h.01c7.03 0 12.74-5.7 12.74-12.74 0-3.4-1.33-6.6-3.73-9A12.66 12.66 0 0 0 16.04 3zm0 23.37h-.01c-1.9 0-3.77-.51-5.4-1.48l-.39-.23-4.07 1.07 1.09-3.97-.25-.41a10.55 10.55 0 0 1-1.620-5.62c0-5.85 4.76-10.6 10.61-10.6 2.83 0 5.49 1.1 7.49 3.11a10.53 10.53 0 0 1 3.1 7.5c0 5.850-4.76 10.6-10.55 10.63zm5.82-7.94c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.030-1 1.24-.18.21-.37.24-.69.08-.32-.16-1.34-.49-2.56-1.57-.95-.84-1.59-1.88-1.77-2.2-.19-.32-.02-.49.14-.65.14-.14.32-.37.48-.56.16-.19.21-.32.32-.53.11-.21.05-.4-.03-.56-.08-.16-.71-1.71-.97-2.34-.26-.62-.52-.53-.71-.54h-.61c-.21 0-.56.08-.85.4-.29.32-1.11 1.09-1.11 2.65s1.14 3.08 1.3 3.29c.16.21 2.24 3.42 5.43 4.8.76.33 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.38.19-1.51-.08-.13-.29-.21-.61-.37z"/></svg></a>';
      document.body.appendChild(wrap);
    }

    var visible = [];
    var blocked = { menu: false, cart: false, search: false };
    var cookieHost = null;

    function update() {
      var hide = isCart || visible.length > 0 || blocked.menu || blocked.cart || blocked.search;
      if (wrap) {
        wrap.classList.toggle('is-hidden', hide);
        wrap.setAttribute('aria-hidden', hide ? 'true' : 'false');
        wrap.querySelectorAll('a').forEach(function (a) { a.tabIndex = hide ? -1 : 0; });
      }
      if (cookieHost) {
        if (hide) cookieHost.setAttribute('data-sm-hide', '');
        else cookieHost.removeAttribute('data-sm-hide');
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var i = visible.indexOf(e.target);
          if (e.isIntersecting && i === -1) visible.push(e.target);
          if (!e.isIntersecting && i !== -1) visible.splice(i, 1);
        });
        update();
      });
      var watch = function () {
        document.querySelectorAll(PROTECT).forEach(function (el) {
          if (el.dataset.smFloatObs) return;
          if (el.closest('.sm-float, .card-wrapper, .product-card-wrapper, .smp-sticky')) return;
          el.dataset.smFloatObs = '1';
          io.observe(el);
        });
      };
      watch();
      window.addEventListener('load', watch);
    }

    function watchClass(selector, key, cls) {
      var els = document.querySelectorAll(selector);
      var check = function () {
        blocked[key] = Array.prototype.some.call(els, function (x) {
          return x.classList.contains(cls) && x.getClientRects().length > 0;
        });
        update();
      };
      els.forEach(function (el) {
        new MutationObserver(check).observe(el, { attributes: true, attributeFilter: ['class'] });
      });
      check();
    }
    watchClass('#SmDrawer', 'menu', 'is-open');
    watchClass('cart-drawer', 'cart', 'active');

    /* Recherche de l'en-tête ouverte (audit UX M04) */
    var searchEls = document.querySelectorAll('.header__search details');
    var checkSearch = function () {
      blocked.search = Array.prototype.some.call(searchEls, function (x) { return x.hasAttribute('open'); });
      update();
    };
    searchEls.forEach(function (el) {
      new MutationObserver(checkSearch).observe(el, { attributes: true, attributeFilter: ['open'] });
    });

    /* Widget cookies Pandectes : composant isolé, chargé après la page. */
    var tries = 0;
    (function findCookie() {
      var host = document.querySelector('pandectes-cmp');
      if (host && host.shadowRoot) {
        var st = document.createElement('style');
        st.textContent = COOKIE_CSS;
        host.shadowRoot.appendChild(st);
        if (tpl.indexOf('product') === 0) host.setAttribute('data-sm-product', '');
        cookieHost = host;
        update();
        return;
      }
      if (++tries < 40) setTimeout(findCookie, 250);
    })();

    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* SeeMy — « Une question ? » sur mobile : WhatsApp au lieu du formulaire de contact
   Audit UX oct. 2026 (M10). Sur téléphone, les liens de question qui mènent à /pages/contact
   ouvrent une conversation WhatsApp avec un message prérempli (nom de la page).
   Sur ordinateur, ils gardent le formulaire. Les demandes d'informations formations ne changent pas. */
(function () {
  var WA = 'https://wa.me/33766481819';
  var LABEL = /une question|une autre question|écrivez-nous|contactez-nous/i;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  if (!mq) return;

  function links() {
    return Array.prototype.filter.call(
      document.querySelectorAll('main a[href]'),
      function (a) {
        var href = a.getAttribute('data-sm-contact') || a.getAttribute('href') || '';
        var label = (a.textContent || '') + ' ' + ((a.parentNode && a.parentNode.textContent) || '');
        return /\/pages\/contact\/?(\?|#|$)/.test(href) && LABEL.test(label) && !/demande d.informations/i.test(a.textContent);
      }
    );
  }

  function topic() {
    var h1 = document.querySelector('main h1');
    if (h1) { h1 = h1.cloneNode(true); h1.querySelectorAll('[class*="subtitle"], .visually-hidden').forEach(function (x) { x.remove(); }); }
    var t = h1 ? h1.textContent.replace(/\s+/g, ' ').trim() : '';
    return t ? 'Bonjour, j’ai une question sur « ' + t + ' ».' : 'Bonjour, j’ai une question.';
  }

  function apply() {
    var mobile = mq.matches;
    links().forEach(function (a) {
      if (!a.hasAttribute('data-sm-contact')) a.setAttribute('data-sm-contact', a.getAttribute('href'));
      if (mobile) {
        a.setAttribute('href', WA + '?text=' + encodeURIComponent(topic()));
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
        a.setAttribute('aria-label', a.textContent.replace(/\s+/g, ' ').trim() + ' : nous écrire sur WhatsApp (nouvelle fenêtre)');
      } else {
        a.setAttribute('href', a.getAttribute('data-sm-contact'));
        a.removeAttribute('target');
        a.removeAttribute('rel');
        a.removeAttribute('aria-label');
      }
    });
  }

  function init() {
    apply();
    if (mq.addEventListener) mq.addEventListener('change', apply); else if (mq.addListener) mq.addListener(apply);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

/* SeeMy — en-tête compact sur mobile — audit UX oct. 2026 (M07)
   La barre d'annonce défile avec la page ; l'en-tête se cache quand on descend
   et réapparaît dès qu'on remonte. Toujours visible en haut de page et quand le menu,
   la recherche ou le panier est ouvert. Sur ordinateur, rien ne change. */
(function () {
  var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
  var sec = document.querySelector('.sm-header-section');
  if (!mq || !sec) return;
  var ann = sec.querySelector('.sm-announce');
  var last = window.pageYOffset, ticking = false, hidden = false;

  function measure() {
    sec.style.setProperty('--sm-ann-h', (ann ? ann.offsetHeight : 0) + 'px');
    sec.style.setProperty('--sm-hdr-h', sec.offsetHeight + 'px');
  }
  function busy() {
    return !!document.querySelector('#SmDrawer.is-open, cart-drawer.active, .header__search details[open], details[open] > .search-modal');
  }
  function set(h) {
    if (h === hidden) return;
    hidden = h;
    sec.classList.toggle('sm-hdr-hidden', h);
  }
  function onScroll() {
    ticking = false;
    var y = window.pageYOffset;
    if (!mq.matches || busy() || y < sec.offsetHeight + 40) { set(false); last = y; return; }
    if (y > last + 6) set(true);
    else if (y < last - 6) set(false);
    last = y;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(onScroll); }
  }, { passive: true });
  window.addEventListener('resize', measure);
  document.addEventListener('focusin', function (e) { if (sec.contains(e.target)) set(false); });
  new MutationObserver(function () { if (busy()) set(false); })
    .observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
  measure();
  window.addEventListener('load', measure);
})();

/* SeeMy — fiches soin : barre « Réserver ce soin » et textes longs repliables — audit UX oct. 2026 (F10)
   - Barre avec le nom, le prix et la durée du soin, repris de la fiche : en bas de l'écran sur mobile
     (la bulle WhatsApp reste à sa place, juste au-dessus), collée sous l'en-tête sur ordinateur.
     Visible une fois le bouton du haut dépassé ; masquée quand un autre bouton de réservation est à l'écran
     et quand le menu ou le panier est ouvert.
   - Sur mobile, les textes de plus de ~6 lignes sont repliés avec « Lire la suite » (texte toujours présent dans la page). */
(function () {
  var page = document.querySelector('.seemy-soin');
  var hero = page && page.querySelector('.ss-hero');
  if (!hero) return;
  var mq = window.matchMedia('(max-width: 749px)');

  /* 1. Barre de réservation */
  var h1 = hero.querySelector('h1');
  var price = hero.querySelector('.ss-price');
  var heroCtas = hero.querySelector('.ss-ctas');
  var book = heroCtas && heroCtas.querySelector('a.ss-btn--dark, a[href*="planity"]');
  if (book && h1) {
    var name = h1.textContent.replace(/\s+/g, ' ').trim();
    var info = price ? price.textContent.replace(/\s+/g, ' ').trim().replace(/minutes?/i, 'min') : '';
    var bar = document.createElement('aside');
    bar.className = 'sm-soinbar';
    bar.setAttribute('aria-label', 'Réserver ce soin');
    bar.innerHTML =
      '<p class="sm-soinbar__txt"><strong></strong><span></span></p>' +
      '<a class="sm-soinbar__btn" href="' + book.getAttribute('href') + '" target="_blank" rel="noopener"><span>Réserver</span><span class="sm-soinbar__long">ce soin</span><span class="visually-hidden"> (nouvelle fenêtre)</span></a>';
    bar.querySelector('strong').textContent = name;
    bar.querySelector('.sm-soinbar__txt span').textContent = info;
    document.body.appendChild(bar);
    document.body.classList.add('sm-has-soinbar');

    var sec = document.querySelector('.sm-header-section');
    var others = function () {
      return document.querySelectorAll('main a[href*="planity.com"], main a[href*="booking.seemycosmetics"], main .ss-ctas, .sm-footer__cta');
    };
    var inView = function (el) {
      var r = el.getBoundingClientRect();
      return r.width > 0 && r.bottom > 0 && r.top < window.innerHeight;
    };
    var shown = null, ticking = false;
    var update = function () {
      ticking = false;
      var past = heroCtas.getBoundingClientRect().bottom < 0;
      var busy = !!document.querySelector('#SmDrawer.is-open, cart-drawer.active, .header__search details[open]');
      var show = past && !busy && !Array.prototype.some.call(others(), inView);
      if (!mq.matches && sec) bar.style.top = Math.max(0, sec.getBoundingClientRect().bottom) + 'px';
      else bar.style.top = '';
      if (show === shown) return;
      shown = show;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (a) { a.tabIndex = show ? 0 : -1; });
    };
    var queue = function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } };
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    new MutationObserver(queue).observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'open'] });
    update();

    /* Widget cookies : remonté au-dessus de la barre sur mobile (même réglage que les fiches produit) */
    var tries = 0;
    (function cookie() {
      var host = document.querySelector('pandectes-cmp');
      if (host) { host.setAttribute('data-sm-product', ''); return; }
      if (++tries < 40) setTimeout(cookie, 250);
    })();
  }

  /* 2. Textes longs repliables sur mobile */
  var LIMIT = 170;
  var blocks = page.querySelectorAll('.ss-section .ss-rte');
  var n = 0;
  blocks.forEach(function (rte) {
    if (rte.closest('details, .ss-faq')) return;
    var id = rte.id || ('sm-more-' + (++n));
    rte.id = id;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'sm-more';
    btn.setAttribute('aria-controls', id);
    rte.insertAdjacentElement('afterend', btn);
    var open = false;
    var render = function () {
      var long = mq.matches && rte.scrollHeight > LIMIT + 90;
      rte.classList.toggle('sm-clamp', long && !open);
      btn.hidden = !long;
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      btn.textContent = open ? 'Réduire' : 'Lire la suite';
    };
    btn.addEventListener('click', function () {
      open = !open;
      render();
      if (!open) rte.scrollIntoView({ block: 'nearest' });
    });
    render();
    if (mq.addEventListener) mq.addEventListener('change', render);
    page.addEventListener('click', function (e) { if (e.target.closest('.ss-tab')) setTimeout(render, 0); });
  });
})();
